import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useExpenseSubCategories, ExpenseSubCategory } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<ExpenseSubCategory>
      useData={useExpenseSubCategories}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

